import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../../auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private redirecting = false;
    constructor(private auth: AuthService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const withCreds = req.clone({ withCredentials: true });

        return next.handle(withCreds).pipe(
            catchError((err: any) => {
                if (err.status === 401) {
                    if (!this.redirecting) {
                        this.redirecting = true;
                        sessionStorage.setItem('auth-redirecting', '1');
                        this.auth.startLogin();
                    }
                } else if (err.status === 403) {
                    this.auth.handleAccessDenied();
                }
                return throwError(() => err);
            })
        );
    }
}
